<template>
  <div id="news-fasney">
    <section class="news-gradient">
      <img
        class="d-none d-md-block w-100"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-header-pc.jpg"
        alt="news-store"
      >
      <img
        class="d-md-none img-fluid"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-header-m.jpg"
        alt="news-store"
      >
      <img
        class="d-none d-md-block w-100"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-content-pc.jpg"
        alt="news-store"
      >
      <img
        class="d-md-none img-fluid"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-content-m.jpg"
        alt="news-store"
      >
      <img
        class="d-none d-md-block w-100"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-footer-pc.jpg"
        alt="news-store"
      >
      <img
        class="d-md-none img-fluid"
        src="https://static.fasney.me/sff/fasney/image/news/discount/november-footer-m.jpg"
        alt="news-store"
      >
    </section>
  </div>
</template>

<script>
export default {
  name: 'NewsEvent2'
}
</script>
